import { getStorageAuthInfo } from '@/utils/storageOperateApi';
import { storage } from '@/utils/storageOperateApi';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { isBuild } from '@/jmHttp/host';

const loopUserMenu = (arr = [], obj) => {
  arr.forEach((item) => {
    if (Array.isArray(item.childModuleList)) {
      loopUserMenu(item.childModuleList, obj);
    }
    if (item.code) {
      obj[item.code] = true;
    }
    if (item.aliasUrl) {
      obj[item.aliasUrl] = true;
    }
  });
};

const sorts = {
  路演管理: 1,
  排会管理: 2,
  研报管理: 3,
  活动管理: 4,
  员工管理: 5,
  客户管理: 6,
  用户管理: 7,
  机构库管理: 8,
  上市公司管理: 9,
  内容运营: 10,
  数据分析: 11,
  账号管理: 12,
  任务管理: 13,
  设置: 14
};

//功能权限

/** 登录后根据组织 ID 更新 store 中的 hiddenFeartByOrg（测试环境 9517，线上环境 3333） */
export function getHiddenFeatByOrg(goId = '') {
  if (!goId) {
    goId = storage.get(LOCAL_STORAGE_KEY.REALM_KEY);
  }
  const targetOrgId = isBuild ? 21782 : 9517;
  return String(goId) === String(targetOrgId);
}
// 权限菜单
export function getOriginMenuKeyToValue() {
  const userInfo = getStorageAuthInfo() || {};
  let originMenus = userInfo.menus || [];

  if (getHiddenFeatByOrg(userInfo.brmToken?.goId)) {
    originMenus = originMenus.filter((item) => item.code === '/summary/list');
  }

  const menuIds = originMenus.map((item) => {
    return {
      name: item.name,
      id: item.id,
      type: item.type,
      code: item.code,
      i18nCode: item.i18nCode,
      i18nGroupCode: item.i18nGroupCode,
      childModuleList: item.childModuleList,
      isNew: item.isNew,
      sortIndex: item.sortIndex,
      moreSortIndex: item.moreSortIndex,
      disableDrag: item.disableDrag,
      isDefaultRoute: item.isDefaultRoute
    };
  });
  const result = {};
  loopUserMenu(menuIds, result);

  menuIds.sort((a, b) => {
    if (!a.name || !b.name || !sorts[a.name] || !sorts[b.name]) return 0;
    return sorts[a.name] - sorts[b.name];
  });

  return {
    menus: menuIds,
    result
  };
}

/**
 * 检查用户是否有某个路由的权限
 * @param {string} routeCode - 路由代码，如 '/reportManage/index'
 * @param {Array} menus - 菜单列表，可选，默认从用户信息中获取
 * @returns {boolean} 是否有权限
 */
export function hasRoutePermission(routeCode, menus = null) {
  const menuList = menus || getOriginMenuKeyToValue().menus;
  return menuList.some(
    (menu) => menu.code === routeCode || menu.childModuleList?.some((child) => child.code === routeCode)
  );
}
